import React, { useState, useMemo } from "react";
import { styled as materialStyles } from "@mui/material/styles";
import CardContent from "@mui/material/CardContent";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import editIcon from "../../../../assets/Group 41.svg";
import deleteIcon from "../../../../assets/Group 115.svg";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { getLocationMastersThunk } from "../../../locationMaster/redux/locationMasterSlice";
import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import styled from "styled-components";
import {
  SelectSpan,
  StyledCard,
  StyledFilledButton,
  StyledOutlineButton,
} from "../StepMain";
import { VendorCardTitle } from "./vendorRegEdit";
import { VendorCardLabel } from "./bankRegEdit";
import { GSTdocument, GSTvalidate } from "../../redux/vendorRegistrationSlice";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalStorage, { SESSION_KEY } from "../../../../utilities/localStorage";
import { message } from "antd";
import { useFeature } from "../../../../common/featureFlags/FeatureProvider";

const Input = materialStyles("input")({
  display: "none",
});

const ContactCard = ({
  index,
  item,
  register,
  onChange,
  onSave,
  onEdit,
  onDelete,
  is_domestic,
}) => {
  const { contact_first_name, contact_last_name, email, mobile_number, designation, edit } = item;
  const contactDesignation = useFeature("contact_designation");

  return (
    <AddContactDiv>
      {edit ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ padding: "15px 15px 0 15px" }}>
              <ContactCardTitle style={{ marginLeft: "30px" }}>
                Add Contact details
              </ContactCardTitle>
            </Grid>
            <Grid sx={{ padding: "15px 15px 0 15px" }} item xs={6}>
              <ContactCardTitle style={{ textAlign: "right" }}>
                <Close onClick={() => onDelete(index)}>
                  <CloseIcon style={{ cursor: "pointer" }} />
                </Close>
              </ContactCardTitle>
            </Grid>
          </Grid>
          <CardContent>
            <Container fixed>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person first name</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`contact_first_name_${index}`}
                    style={{ width: "100%" }}
                    {...register(`contact_first_name_${index}`, {
                      required: "Please enter First name",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter first name"
                    value={contact_first_name || ""}
                    onChange={(e) => onChange({ target: { name: "contact_first_name", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person last name</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`contact_last_name_${index}`}
                    style={{ width: "100%" }}
                    {...register(`contact_last_name_${index}`, {
                      required: "Please enter Last name",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter last name"
                    value={contact_last_name || ""}
                    onChange={(e) => onChange({ target: { name: "contact_last_name", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person email</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`email_${index}`}
                    style={{ width: "100%" }}
                    {...register(`email_${index}`, {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Entered value does not match email format",
                      },
                      required: "Please enter email",
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter e-mail"
                    value={email || ""}
                    onChange={(e) => onChange({ target: { name: "email", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Contact person mobile</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    id={`mobile_number_${index}`}
                    style={{ width: "100%" }}
                    {...register(`mobile_number_${index}`, {
                      pattern: {
                        value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
                        message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
                      },
                    })}
                    InputProps={{
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    placeholder="Enter mobile number"
                    value={mobile_number || ""}
                    onChange={(e) => onChange({ target: { name: "mobile_number", value: e.target.value } }, index)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <VendorCardLabel>Designation</VendorCardLabel>
                  {contactDesignation ? (
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        sx={{
                          fontFamily: "var(--font-family-reg)",
                          fontSize: "14px",
                        }}
                        id={`designation_${index}`}
                        value={designation || ""}
                        onChange={(e) => onChange({ target: { name: "designation", value: e.target.value } }, index)}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <span style={{ fontSize: "14px", color: "#A5A5BA" }}>Select designation</span>
                        </MenuItem>
                        <MenuItem value="Sales">Sales</MenuItem>
                        <MenuItem value="Marketing">Marketing</MenuItem>
                        <MenuItem value="Accounts">Accounts</MenuItem>
                        <MenuItem value="Finance">Finance</MenuItem>
                        <MenuItem value="Support">Support</MenuItem>
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`designation_${index}`}
                      style={{ width: "100%" }}
                      {...register(`designation_${index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter designation"
                      value={designation || ""}
                      onChange={(e) => onChange({ target: { name: "designation", value: e.target.value } }, index)}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6} md={8}></Grid>
                <Grid item xs={6} md={4}>
                  <StyledFilledButton
                    variant="contained"
                    color="success"
                    style={{ textAlign: "right", float: "right" }}
                    onClick={() => onSave(index)}
                  >
                    Save
                  </StyledFilledButton>
                  <br />
                </Grid>
              </Grid>
            </Container>
          </CardContent>
        </>
      ) : (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={10}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={3}>
                <DarkText>{`${contact_first_name || ""} ${contact_last_name || ""}`}</DarkText>
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={3}>
                {email ? <LightText>{email}</LightText> : null}
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={2}>
                {mobile_number ? <LightText>{mobile_number}</LightText> : null}
              </Grid>
              <Grid item xs={1}>
                <Dot />
              </Grid>
              <Grid item xs={1}>
                {designation ? <LightText>{designation}</LightText> : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1}>
            <Grid container spacing={1}>
              <Grid
                item
                xs={6}
                style={{ cursor: "pointer" }}
                onClick={() => onEdit(index)}
              >
                <div style={{ cursor: "pointer" }}>
                  <img src={editIcon} alt="edit" />
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                style={{ cursor: "pointer" }}
                onClick={() => onDelete(index)}
              >
                <div style={{ cursor: "pointer" }}>
                  <img src={deleteIcon} alt="delete" />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </AddContactDiv>
  );
};

const LocationInfo = ({
  clientId,
  l_index,
  register,
  onChange,
  phone,
  branch_email,
  fax_number,
  state,
  city,
  address_line_one,
  address_line_two,
  postal_code,
  errors,
  is_domestic,
}) => {
  const clean = (val) => (val === "null" || val === "undefined") ? "" : (val || "");
  const isVendorApproval = useFeature("vendor_approval_workflow");

  const phoneRegProps = register(`phone_${l_index}`, {
    pattern: {
      value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
      message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
    },
    required: "Please enter phone number",
  });

  const emailRegProps = register(`branch_email_${l_index}`, {
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Entered value does not match email format",
    },
    required: "Please enter email",
  });

  return (
    <CardContent>
      <Container fixed>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Country</VendorCardLabel>
            <BankDisabledFields>India</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>State</VendorCardLabel>
            <BankDisabledFields>{clean(state)}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>City</VendorCardLabel>
            <BankDisabledFields>{clean(city)}</BankDisabledFields>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Address Line 1</VendorCardLabel>
            <BankDisabledFields>{clean(address_line_one)}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Address Line 2</VendorCardLabel>
            <BankDisabledFields>{clean(address_line_two)}</BankDisabledFields>
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>Postal Code</VendorCardLabel>
            <BankDisabledFields>{clean(postal_code)}</BankDisabledFields>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>
              Phone<Super>*</Super>
            </VendorCardLabel>
            <TextField
              {...phoneRegProps}
              error={Boolean(errors?.[`phone_${l_index}`])}
              helperText={errors?.[`phone_${l_index}`]?.message}
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
                width: "100%",
              }}
              id={`phone_${l_index}`}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter Phone"
              value={clean(phone)}
              onChange={(e) => {
                phoneRegProps.onChange(e);
                onChange(e, l_index);
              }}
              disabled={isVendorApproval && clean(phone) ? true : false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>
              Branch e-mail for communication <Super>*</Super>
            </VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              id={`branch_email_${l_index}`}
              style={{ width: "100%" }}
              {...emailRegProps}
              error={Boolean(errors?.[`branch_email_${l_index}`])}
              helperText={errors?.[`branch_email_${l_index}`]?.message}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter email"
              value={clean(branch_email)}
              onChange={(e) => {
                emailRegProps.onChange(e);
                onChange(e, l_index);
              }}
              disabled={isVendorApproval && clean(branch_email) ? true : false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <VendorCardLabel>FAX number</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              id={`fax_number_${l_index}`}
              style={{ width: "100%" }}
              {...register(`fax_number_${l_index}`)}
              InputProps={{
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              placeholder="Enter FAX"
              value={clean(fax_number)}
              onChange={(e) => onChange(e, l_index)}
              disabled={isVendorApproval && clean(phone) ? true : false}
            />
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );
};

const ExpandMore = materialStyles((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Close = materialStyles((props) => {
  const { ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function RecipeReviewCard({
  l_index,
  location_item,
  allLocations = [],
  register,
  expanded,
  handleExpandClick,
  contacts,
  setContacts,
  onChange,
  onDelete,
  errors,
  clearErrors,
  registerType,
  clientId,
  is_domestic,
  setValue,
}) {
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const hideGstRemove = useFeature("hide_gst_remove");
  const showLocationMaster = useFeature("show_location_master");
  const dispatch = useDispatch();
  const { locationMasterList } = useSelector((state) => state.locationMaster || {});

  React.useEffect(() => {
    if (showLocationMaster && (!locationMasterList || locationMasterList.length === 0)) {
      dispatch(getLocationMastersThunk({ page: 1, per_page: 1000 }));
    }
  }, [showLocationMaster, dispatch, locationMasterList]);

  const selectedOtherSiteCodes = useMemo(() => {
    const codes = new Set();
    (allLocations || []).forEach((loc, idx) => {
      if (idx !== l_index && loc?.location_code) {
        codes.add(String(loc.location_code).trim().toUpperCase());
      }
    });
    return codes;
  }, [allLocations, l_index]);

  let {
    gst_id,
    is_gst_valid,
    location,
    location_code,
    location_master_id,
    phone,
    branch_email,
    fax_number,
    country,
    state,
    city,
    address_line_one,
    address_line_two,
    postal_code,
    gst_document_image_name,
    gst_document_image,
    user_id,
  } = location_item;

  const isExistingLocation = Boolean(location_item?.id) && !location_item?.is_pending_new;
  const isGstIdEmpty = !gst_id || gst_id === "null" || gst_id === "undefined" || (typeof gst_id === "string" && gst_id.trim() === "");
  const isGstLocked = isVendorApproval && isExistingLocation && !isGstIdEmpty;
  const displayGstId = (gst_id === "null" || gst_id === "undefined") ? "" : gst_id;

  const isGstDocEmpty = !gst_document_image_name || gst_document_image_name === "null" || gst_document_image_name === "undefined" || (typeof gst_document_image_name === "string" && gst_document_image_name.trim() === "");

  const clean = (val) => (val === "null" || val === "undefined") ? "" : (val || "");

  const isGstRequired = is_domestic === true && registerType !== "unregistered";
  const gstRegister = register(`gst_document_image_name_${l_index}`, {
    required: isGstRequired && isGstDocEmpty ? "Please upload GST copy" : false,
  });
  const loginRole = LocalStorage.getItem(SESSION_KEY)?.roles;
  const [dropdownValue, setdropdownValue] = useState(location);

  const handleAddContact = () => {
    let contactsCopy = [...(contacts || [])];

    contactsCopy.push({
      contact_first_name: "",
      contact_last_name: "",
      email: "",
      mobile_number: "",
      designation: "",
      edit: true,
    });

    setContacts(contactsCopy);
  };

  const handleContactOnchange = (e, index) => {
    const { name, value } = e.target;

    let contactsCopy = [...contacts];

    contactsCopy[index] = {
      ...(contactsCopy[index] || {}),
      [name]: value,
    };

    setContacts(contactsCopy);
  };

  const [selectedlocation, setSelectedlocation] = useState({});

  // var user = LocalStorage.getItem(SESSION_KEY);
  // const is_domestic = user.is_domestic;

  const onDocumentChange = (e) => {
    const { name, files } = e.target;

    // let formData = new FormData();
    // formData.append("file", files[0]);
    // if (loginRole.includes("officer" || "super admin")) {
    //   dispatch(GSTdocument(formData)).then((response) => {
    //     const { data } = response.payload;
    //     onChange(
    //       {
    //         target: { name: "gst_document_image_name", value: data?.file_name },
    //       },
    //       l_index
    //     );
    //     onChange(
    //       { target: { name: "gst_document_image", value: data?.location } },
    //       l_index
    //     );
    //   });
    // } else {
    if (clearErrors) {
      clearErrors(`gst_document_image_name_${l_index}`);
    }
    onChange(
      {
        target: {
          name: "gst_document_image_name",
          value: files[0],
        },
      },
      l_index
    );
    // }
  };

  const handleLocationOnchange = (e, index) => {
    const val = e.target.value;
    const addresses = location_item?.addresses || gstLocations[index]?.addresses || gstLocations[l_index]?.addresses || [];
    const unique = addresses.find(
      (aLeague) =>
        aLeague?.addr &&
        (aLeague.addr.loc + aLeague.addr.st + aLeague.addr.pncd === val ||
          aLeague.addr.loc === val)
    );
    setdropdownValue(val);
    setSelectedlocation(unique || {});

    let updatedFields = {};
    if (unique?.addr) {
      updatedFields.location = unique.addr.loc || "";
      updatedFields.state = unique.addr.stcd || "";
      updatedFields.city = unique.addr.dst || "";
      updatedFields.address_line_one = `${unique.addr.flno || ""} ${unique.addr.bno || ""} ${unique.addr.bnm || ""}`.trim();
      updatedFields.address_line_two = `${unique.addr.st || ""} ${unique.addr.landMark || ""} ${unique.addr.locality || ""}`.trim();
      updatedFields.postal_code = unique.addr.pncd || "";
    } else {
      updatedFields.location = val;
    }
    updatedFields.selected_address_key = val;
    updatedFields.country = is_domestic === true ? "India" : country;

    onChange(updatedFields, index);
  };
  const handleSaveContact = (index) => {
    let contactsCopy = [...contacts];

    for (let i = 0; i < contactsCopy.length; i++) {
      const contact = contactsCopy[i];
      const { contact_first_name, contact_last_name, email, mobile_number, designation } = contact;

      if (
        !contact_first_name || contact_first_name.trim() === "" ||
        !contact_last_name || contact_last_name.trim() === "" ||
        !email || email.trim() === "" ||
        !mobile_number || mobile_number.trim() === "" ||
        !designation || designation.trim() === ""
      ) {
        contactsCopy.splice(i, 1);
        setContacts(contactsCopy);
        message.error("All contact fields are required");
        return;
      }
      contactsCopy[i] = {
        ...contact,
        edit: false,
      };
    }
    setContacts(contactsCopy);
  };

  const handleEditContact = (index) => {
    let contactsCopy = [...contacts];

    contactsCopy[index] = {
      ...(contactsCopy[index] || {}),
      edit: true,
    };

    setContacts(contactsCopy);
  };

  const handleDeleteContact = (index) => {
    let contactsCopy = [...contacts];
    // eslint-disable-next-line
    contactsCopy = contactsCopy.filter((_, i) => i !== index);

    setContacts(contactsCopy);
  };
  const [gstLocations, setGstLocations] = useState([]);
  const [gstValidating, setGstValidating] = useState(false);

  let gstin = { gstin: gst_id };

  if (loginRole.includes("officer") || loginRole.includes("super admin")) {
    gstin = { ...gstin, data: { user_id: user_id } };
  }
  const validateGST = (e, index) => {
    const GSTRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
    if (GSTRegex.test(gst_id?.toUpperCase())) {
      setGstValidating(true);
      dispatch(GSTvalidate(gstin))
        .then((data) => {
          setGstValidating(false);
          if (data?.payload?.success === true) {
            const data1 = data.payload.gst_api_result.data
              ? data.payload.gst_api_result.data.adadr
              : [];

            const data2 = data.payload.gst_api_result.data
              ? data.payload.gst_api_result.data.pradr
              : [];

            const addresses = [...data1, data2];
            let gstCopy = [...gstLocations];
            gstCopy[index] = {
              ...(gstCopy[index] || {}),
              addresses,
            };

            setGstLocations(gstCopy);
            setdropdownValue("");
            setSelectedlocation({});

            // Mark the location as GST-validated and clear dependent fields
            onChange(
              {
                is_gst_valid: true,
                addresses,
                selected_address_key: "",
                location: "",
                phone: "",
                branch_email: "",
                fax_number: "",
              },
              l_index
            );
          } else {
            const msg = data?.payload?.message;
            message.error(
              msg
                ? msg.includes("Business location")
                  ? msg
                  : `Business location ${l_index + 1}: ${msg}`
                : `Business location ${l_index + 1}: GST validation failed`
            );
          }
        })
        .catch((err) => {
          setGstValidating(false);
          message.error(
            err?.message || `Business location ${l_index + 1}: GST validation failed`
          );
        });
    } else {
      message.error(`Business location ${l_index + 1}: Please enter valid GST number`);
    }
  };

  const addressesList = location_item?.addresses || gstLocations[l_index]?.addresses || [];
  const matchingAddress = addressesList.find(
    (item) =>
      item?.addr &&
      (item.addr.loc === location ||
        (item.addr.loc === location && String(item.addr.pncd) === String(location_item?.postal_code)))
  );
  const currentDropdownValue =
    location_item?.selected_address_key ||
    (matchingAddress
      ? matchingAddress.addr.loc + matchingAddress.addr.st + matchingAddress.addr.pncd
      : location || dropdownValue || "");

  return (
    <StyledCard>
      <CardContent>
        <Container fixed>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={8}>
                <VendorCardTitle>
                  Business location {l_index + 1}
                  {onDelete && (
                    <DeleteOuterContainer onClick={() => onDelete(l_index)}>
                      <img src={deleteIcon} alt="del" />
                    </DeleteOuterContainer>
                  )}
                </VendorCardTitle>
              </Grid>
              <Grid item xs={6} md={4}>
                <ExpandMore
                  expand={expanded}
                  onClick={() => handleExpandClick(l_index)}
                  aria-expanded={expanded}
                  aria-label="show more"
                  style={{ textAlign: "right", float: "right" }}
                >
                  <ExpandMoreIcon />
                </ExpandMore>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </CardContent>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          {is_domestic === true && registerType !== "unregistered" ? (
            <Container fixed>
              <BusinessRegistrationSubTitle>
                GST information
              </BusinessRegistrationSubTitle>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                  <VendorCardLabel>
                    GST ID <Super>*</Super>
                  </VendorCardLabel>
                  <Box sx={{ display: "flex", alignItems: "flex-end", gap: 2, maxWidth: "600px" }}>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`gst_id_${l_index}`}
                      {...register(`gst_id_${l_index}`, {
                        required: isGstRequired ? "Please enter GST number" : false,
                        value: displayGstId,
                        pattern: isGstRequired ? {
                          value:
                            /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[a-zA-Z0-9]{1}[zZ]{1}[a-zA-Z0-9]{1}$/,
                          message: "Please enter valid GST number",
                        } : undefined,
                      })}
                      error={Boolean(errors?.[`gst_id_${l_index}`])}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter GST and validate"
                      style={{ flex: 1 }}
                      value={displayGstId}
                      disabled={isGstLocked}
                      onChange={(e) => {
                        onChange(
                          { target: { name: "gst_id", value: e.target.value } },
                          l_index,
                        );
                        onChange(
                          { target: { name: "is_gst_valid", value: false } },
                          l_index,
                        );
                      }}
                    />
                    <LoadingButton
                      variant="contained"
                      loading={gstValidating}
                      startIcon={is_gst_valid ? <CheckCircleIcon /> : null}
                      sx={{
                        width: "150px",
                        height: "36px",
                        flexShrink: 0,
                        backgroundColor: is_gst_valid ? "#4caf50" : undefined,
                        "&:hover": is_gst_valid
                          ? { backgroundColor: "#388e3c" }
                          : undefined,
                        pointerEvents: is_gst_valid ? "none" : "auto",
                      }}
                      onClick={(e) => validateGST(e, l_index)}
                      disabled={
                        isGstLocked ||
                        !displayGstId ||
                        displayGstId.trim() === ""
                      }
                    >
                      {is_gst_valid ? "Validated" : "Validate GST"}
                    </LoadingButton>
                  </Box>
                  {errors?.[`gst_id_${l_index}`] && (
                    <FormHelperText error sx={{ marginTop: "4px" }}>
                      {errors?.[`gst_id_${l_index}`]?.message}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <FormControl
                    variant="standard"
                    style={{ width: "100%" }}
                    error={Boolean(errors?.[`gst_document_image_name_${l_index}`])}
                  >
                    <VendorCardLabel
                      style={{ fontWeight: "500", fontSize: "14px" }}
                    >
                      Upload GST Document<Super>*</Super>
                    </VendorCardLabel>
                    {!isGstDocEmpty ? (
                      <>
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={
                              gst_document_image_name?.name
                                ? gst_document_image_name?.name
                                : gst_document_image_name
                            }
                            {...((gst_document_image || "").includes("http")
                              ? {
                                component: "a",
                                clickable: true,
                                href: gst_document_image,
                                target: "_blank",
                              }
                              : {})}
                          />
                          {(!hideGstRemove || isGstIdEmpty) && (
                            <>
                              <HighlightOffIcon
                                sx={{ color: "#4945FF", cursor: "pointer", marginLeft: "4px" }}
                                fontSize="medium"
                                onClick={() =>
                                  onChange(
                                    {
                                      target: {
                                        name: "gst_document_image_name",
                                        value: "",
                                      },
                                    },
                                    l_index
                                  )
                                }
                              />
                              <span style={{ marginLeft: "4px" }}>Remove </span>
                            </>
                          )}
                        </span>
                      </>
                    ) : (
                      <label htmlFor={`gst_document_image_name_${l_index}`}>
                        <Input
                          accept="*"
                          id={`gst_document_image_name_${l_index}`}
                          name={`gst_document_image_name_${l_index}`}
                          value=""
                          onChange={(e) => {
                            gstRegister.onChange(e);
                            onDocumentChange(e);
                          }}
                          type="file"
                        />
                        <StyledOutlineButton
                          style={{ marginTop: "5px" }}
                          variant="outlined"
                          component="span"
                        >
                          Upload
                        </StyledOutlineButton>
                      </label>
                    )}
                    {isGstDocEmpty ? (
                      <FormHelperText>
                        {errors?.[`gst_document_image_name_${l_index}`]?.message}
                      </FormHelperText>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>
              </Grid>

              <br />
              <br />
              <VendorCardTitle>Location information</VendorCardTitle>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl
                    variant="standard"
                    style={{ width: "100%" }}
                    error={Boolean(errors?.[`location_${l_index}`])}
                  >
                    <VendorCardLabel>
                      Select location <Super>*</Super>
                    </VendorCardLabel>
                    <Select
                      sx={{
                        fontFamily: "var(--font-family-reg)",
                        fontSize: "14px",
                      }}
                      displayEmpty
                      defaultValue=""
                      IconComponent={() => (
                        <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                      )}
                      id={`location_${l_index}`}
                      {...register(`location_${l_index}`, {
                        required: is_gst_valid ? "Please select location" : false,
                        value: `${currentDropdownValue}`,
                      })}
                      error={Boolean(errors?.[`location_${l_index}`])}
                      value={currentDropdownValue || ""}
                      onChange={(e) => {
                        if (clearErrors) {
                          clearErrors(`location_${l_index}`);
                        }
                        handleLocationOnchange(e, l_index);
                      }}
                    >
                      <MenuItem value="">
                        <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                          Select location
                        </span>
                      </MenuItem>

                      {addressesList.length > 0 ? (
                        addressesList.map((item, index) => {
                          const itemVal = item?.addr
                            ? item.addr.loc + item.addr.st + item.addr.pncd
                            : "";
                          return (
                            <MenuItem key={index} value={itemVal}>
                              <SelectSpan>
                                {item?.addr
                                  ? `${item.addr.loc}, ${item.addr.st} (${item.addr.pncd})`
                                  : ""}
                              </SelectSpan>
                            </MenuItem>
                          );
                        })
                      ) : location_item !== "" && location_item?.location ? (
                        <MenuItem value={location_item.location}>
                          <SelectSpan>{location_item.location}</SelectSpan>
                        </MenuItem>
                      ) : null}
                      {currentDropdownValue &&
                        !addressesList.some(
                          (item) =>
                            item?.addr &&
                            (item.addr.loc + item.addr.st + item.addr.pncd === currentDropdownValue ||
                              item.addr.loc === currentDropdownValue)
                        ) && (
                          <MenuItem value={currentDropdownValue}>
                            <SelectSpan>{location || currentDropdownValue}</SelectSpan>
                          </MenuItem>
                        )}
                    </Select>
                    {errors?.[`location_${l_index}`] ? (
                      <FormHelperText>
                        {errors?.[`location_${l_index}`]?.message || "Please select location"}
                      </FormHelperText>
                    ) : (
                      ""
                    )}
                  </FormControl>
                </Grid>
                {showLocationMaster ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <VendorCardLabel>
                      Site<Super>*</Super>
                    </VendorCardLabel>
                    <FormControl variant="standard" style={{ width: "100%" }}>
                      <Select
                        sx={{
                          fontFamily: "var(--font-family-reg)",
                          fontSize: "14px",
                        }}
                        id={`location_master_id_${l_index}`}
                        value={
                          location_master_id ||
                          (locationMasterList || []).find(
                            (m) => m.location_code === location_code
                          )?.id ||
                          ""
                        }
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const selectedMaster = (locationMasterList || []).find(
                            (m) => String(m.id) === String(selectedId)
                          );
                          if (selectedMaster) {
                            if (
                              selectedOtherSiteCodes.has(
                                String(selectedMaster.location_code || "").trim().toUpperCase()
                              )
                            ) {
                              message.warning(
                                `Site code ${selectedMaster.location_code} is already selected for another Business location.`
                              );
                              return;
                            }
                            onChange(
                              {
                                target: {
                                  name: "location_master_id",
                                  value: selectedMaster.id,
                                },
                              },
                              l_index
                            );
                            onChange(
                              {
                                target: {
                                  name: "location_code",
                                  value: selectedMaster.location_code,
                                },
                              },
                              l_index
                            );
                            if (typeof setValue === "function") {
                              setValue(`location_code_${l_index}`, selectedMaster.location_code);
                              setValue(`location_master_id_${l_index}`, selectedMaster.id);
                            }
                            if (typeof clearErrors === "function") {
                              clearErrors(`location_code_${l_index}`);
                            }
                          } else {
                            onChange(
                              {
                                target: {
                                  name: "location_master_id",
                                  value: "",
                                },
                              },
                              l_index
                            );
                            onChange(
                              {
                                target: {
                                  name: "location_code",
                                  value: "",
                                },
                              },
                              l_index
                            );
                          }
                        }}
                      >
                        <MenuItem value="">
                          <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                            Select Site
                          </span>
                        </MenuItem>
                        {(locationMasterList || []).map((m) => {
                          const isAlreadySelected = selectedOtherSiteCodes.has(
                            String(m.location_code || "").trim().toUpperCase()
                          );
                          return (
                            <MenuItem
                              key={m.id}
                              value={m.id}
                              disabled={isAlreadySelected}
                              sx={
                                isAlreadySelected
                                  ? { color: "#A5A5BA", fontStyle: "italic" }
                                  : {}
                              }
                            >
                              <SelectSpan>
                                {m.location_name} ({m.location_code})
                                {isAlreadySelected ? " - (Already selected)" : ""}
                              </SelectSpan>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                ) : null}
              </Grid>
              <br />
              <br />

              {location ? (
                <LocationInfo
                  clientId={clientId}
                  l_index={l_index}
                  register={register}
                  onChange={onChange}
                  phone={phone}
                  branch_email={branch_email}
                  fax_number={fax_number}
                  state={
                    selectedlocation?.addr
                      ? selectedlocation?.addr?.stcd
                      : location_item.state
                  }
                  city={
                    selectedlocation?.addr
                      ? selectedlocation?.addr?.dst
                      : location_item.city
                  }
                  address_line_one={
                    selectedlocation?.addr
                      ? `${selectedlocation?.addr?.flno} ${selectedlocation?.addr?.bno} ${selectedlocation?.addr?.bnm}`
                      : location_item.address_line_one
                  }
                  address_line_two={
                    selectedlocation?.addr
                      ? `${selectedlocation?.addr?.st} ${selectedlocation?.addr?.landMark} ${selectedlocation?.addr?.locality}`
                      : location_item.address_line_two
                  }
                  postal_code={
                    selectedlocation?.addr
                      ? selectedlocation?.addr?.pncd
                      : location_item.postal_code
                  }
                  errors={errors}
                  is_domestic={is_domestic}
                />
              ) : null}
            </Container>
          ) : (
            <CardContent>
              <Container fixed>
                <Grid container spacing={2}>
                  {showLocationMaster ? (
                    <>
                      <Grid item xs={12} md={4}>
                        <VendorCardLabel>
                          Site<Super>*</Super>
                        </VendorCardLabel>
                        <FormControl variant="standard" style={{ width: "100%" }}>
                          <Select
                            sx={{
                              fontFamily: "var(--font-family-reg)",
                              fontSize: "14px",
                            }}
                            id={`location_master_id_${l_index}`}
                            value={
                              location_master_id ||
                              (locationMasterList || []).find(
                                (m) => m.location_code === location_code
                              )?.id ||
                              ""
                            }
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedMaster = (locationMasterList || []).find(
                                (m) => String(m.id) === String(selectedId)
                              );
                              if (selectedMaster) {
                                if (
                                  selectedOtherSiteCodes.has(
                                    String(selectedMaster.location_code || "").trim().toUpperCase()
                                  )
                                ) {
                                  message.warning(
                                    `Site code ${selectedMaster.location_code} is already selected for another Business location.`
                                  );
                                  return;
                                }
                                onChange(
                                  {
                                    ...location_item,
                                    location_master_id: selectedMaster.id,
                                    location: selectedMaster.location_name,
                                    location_code: selectedMaster.location_code,
                                  },
                                  l_index
                                );
                                if (typeof setValue === "function") {
                                  setValue(`location_${l_index}`, selectedMaster.location_name);
                                  setValue(`location_code_${l_index}`, selectedMaster.location_code);
                                  setValue(`location_master_id_${l_index}`, selectedMaster.id);
                                }
                                if (typeof clearErrors === "function") {
                                  clearErrors(`location_${l_index}`);
                                  clearErrors(`location_code_${l_index}`);
                                }
                              } else {
                                onChange(
                                  {
                                    ...location_item,
                                    location_master_id: "",
                                    location: "",
                                    location_code: "",
                                  },
                                  l_index
                                );
                              }
                            }}
                          >
                            <MenuItem value="">
                              <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                                Select Site
                              </span>
                            </MenuItem>
                            {(locationMasterList || []).map((loc) => {
                              const isAlreadySelected = selectedOtherSiteCodes.has(
                                String(loc.location_code || "").trim().toUpperCase()
                              );
                              return (
                                <MenuItem
                                  key={loc.id}
                                  value={loc.id}
                                  disabled={isAlreadySelected}
                                  sx={
                                    isAlreadySelected
                                      ? { color: "#A5A5BA", fontStyle: "italic" }
                                      : {}
                                  }
                                >
                                  <SelectSpan>
                                    {loc.location_name} ({loc.location_code})
                                    {isAlreadySelected ? " - (Already selected)" : ""}
                                  </SelectSpan>
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {errors?.[`location_${l_index}`] && (
                            <FormHelperText error>
                              {errors?.[`location_${l_index}`]?.message || "Please select site"}
                            </FormHelperText>
                          )}
                        </FormControl>
                        <input
                          type="hidden"
                          {...register(`location_${l_index}`, {
                            required: "Please select Site",
                          })}
                          value={location || ""}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <VendorCardLabel>
                          Site Code<Super>*</Super>
                        </VendorCardLabel>
                        <TextField
                          sx={{
                            input: {
                              fontSize: "14px",
                              fontFamily: "var(--font-family-reg)",
                            },
                          }}
                          id={`location_code_${l_index}`}
                          style={{ width: "100%" }}
                          disabled
                          size="small"
                          variant="standard"
                          placeholder="Auto-filled from site"
                          value={location_code || ""}
                        />
                        <input
                          type="hidden"
                          {...register(`location_code_${l_index}`, {
                            required: "Please select Site",
                          })}
                          value={location_code || ""}
                        />
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12} md={4}>
                      <VendorCardLabel>
                        Branch<Super>*</Super>
                      </VendorCardLabel>
                      <TextField
                        sx={{
                          input: {
                            fontSize: "14px",
                            fontFamily: "var(--font-family-reg)",
                          },
                        }}
                        id={`location_${l_index}`}
                        style={{ width: "100%" }}
                        {...register(`location_${l_index}`)}
                        error={Boolean(errors?.[`location_${l_index}`])}
                        helperText={errors?.[`location_${l_index}`]?.message}
                        InputProps={{
                          disableInjectingGlobalStyles: true,
                        }}
                        InputLabelProps={{
                          disableAnimation: true,
                          disableInjectingGlobalStyles: true,
                        }}
                        size="small"
                        variant="standard"
                        placeholder="Enter Branch name"
                        name="location"
                        value={clean(location)}
                        onChange={(e) => onChange(e, l_index)}
                      />
                    </Grid>
                  )}
                </Grid>
                <br />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Country</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`country_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`country_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter Country name"
                      value={clean(country)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      State<Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`state_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`state_${l_index}`)}
                      error={Boolean(errors?.[`state_${l_index}`])}
                      helperText={errors?.[`state_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter state name"
                      value={clean(state)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>City</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`city_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`city_${l_index}`, {
                        required: !isGstRequired ? "Please enter city" : false,
                        value: clean(city),
                      })}
                      error={Boolean(errors?.[`city_${l_index}`])}
                      helperText={errors?.[`city_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter city"
                      value={clean(city)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Address Line 1</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`address_line_one_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`address_line_one_${l_index}`)}
                      error={Boolean(errors?.[`address_line_one_${l_index}`])}
                      helperText={errors?.[`address_line_one_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter address line 1"
                      value={clean(address_line_one)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Address Line 2</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`address_line_two_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`address_line_two_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter address line2"
                      value={clean(address_line_two)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>Postal Code</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`postal_code_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`postal_code_${l_index}`, {
                        pattern: {
                          value: is_domestic ? /^[1-9][0-9]{5}$/ : /^[a-zA-Z0-9 -]{3,10}$/,
                          message: is_domestic ? "Postal code should be a 6-digit number" : "Postal code should be 3 to 10 alphanumeric characters",
                        },
                        required: "Please enter postal code",
                        value: clean(postal_code),
                      })}
                      error={Boolean(errors?.[`postal_code_${l_index}`])}
                      helperText={errors?.[`postal_code_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter postal code"
                      value={clean(postal_code)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Phone<Super>*</Super>
                    </VendorCardLabel>

                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`phone_${l_index}`}
                      style={{ width: "100%" }}
                      {...(() => {
                        const reg = register(`phone_${l_index}`, {
                          pattern: {
                            value: is_domestic ? /^(?:\d{10}|\d{12})$/ : /^(?:\d{9}|\d{11})$/,
                            message: is_domestic ? "Phone number should be 10 or 12-digit" : "Phone number should be 9 or 11-digit",
                          },
                          required: "Please enter phone number",
                        });
                        return {
                          ...reg,
                          onChange: (e) => { reg.onChange(e); onChange(e, l_index); },
                        };
                      })()}
                      error={Boolean(errors?.[`phone_${l_index}`])}
                      helperText={errors?.[`phone_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter Phone"
                      value={clean(phone ? phone : location_item.phone)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Branch e-mail for communication <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`branch_email_${l_index}`}
                      style={{ width: "100%" }}
                      {...(() => {
                        const reg = register(`branch_email_${l_index}`, {
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Entered value does not match email format",
                          },
                          required: "Please enter email",
                        });
                        return {
                          ...reg,
                          onChange: (e) => { reg.onChange(e); onChange(e, l_index); },
                        };
                      })()}
                      error={Boolean(errors?.[`branch_email_${l_index}`])}
                      helperText={errors?.[`branch_email_${l_index}`]?.message}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter email"
                      value={clean(branch_email)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>FAX number</VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      id={`fax_number_${l_index}`}
                      style={{ width: "100%" }}
                      {...register(`fax_number_${l_index}`)}
                      InputProps={{
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      placeholder="Enter FAX"
                      value={clean(fax_number)}
                      onChange={(e) => onChange(e, l_index)}
                    />
                  </Grid>
                </Grid>
              </Container>
            </CardContent>
          )}
          <br />
          <Container fixed>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={8}>
                  <VendorCardTitle>Contacts</VendorCardTitle>
                </Grid>
                <Grid item xs={6} md={4}>
                  <StyledOutlineButton
                    onClick={handleAddContact}
                    style={{ textAlign: "right", float: "right" }}
                  >
                    Add Contact
                  </StyledOutlineButton>
                  <br />
                </Grid>
              </Grid>
            </Box>
            <VendorCardSubTitle>
              {contacts && contacts.length === 0
                ? "No contacts added yet. Start adding contacts by clicking on Add contact button in the right."
                : ""}
            </VendorCardSubTitle>
            {contacts
              ? contacts.map((item, index) => (
                <ContactCard
                  key={index}
                  index={index}
                  item={item}
                  register={register}
                  onChange={handleContactOnchange}
                  onSave={handleSaveContact}
                  onEdit={handleEditContact}
                  onDelete={handleDeleteContact}
                  is_domestic={is_domestic}
                />
              ))
              : ""}
          </Container>
        </CardContent>
      </Collapse>
    </StyledCard>
  );
}

export const BusinessRegistrationSubTitle = styled.div`
  font-family: var(--font-family-semi-bold);
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #212134;
`;

export const Super = styled.sup`
  color: red;
`;

export const VendorCardSubTitle = styled.div`
  margin-top: 10px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  color: #666687;
`;

export const AddContactDiv = styled.div`
  padding: 10px;
  text-align: left;
  font-family: var(--font-family-reg);
  background: #f5f7f9;
  border: 1px solid #ebeff3;
  border-radius: 10px;
  margin-bottom: 10px;
`;

export const ContactCardTitle = styled.div`
  margin: 10px;
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
`;

export const ContactIconOuterContianer = styled.div`
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #ebeff3;
  border-radius: 4px;
  /* padding: 7px; */
  padding-left: 6px;
  width: 28px;
  height: 28px;
`;

export const Dot = styled.div`
  background: #a5a5ba;
  height: 4px;
  width: 4px;
  border-radius: 100%;
`;

export const DarkText = styled.span`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`;

export const LightText = styled.span`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #4a4a6a;
`;

export const BankDisabledFields = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/900 */

  color: #212134;
`;

export const DeleteOuterContainer = styled.span`
  cursor: pointer;
  background: #f5f7f9;
  border: 1px solid #ebeff3;
  border-radius: 4px;
  /* padding: 7px; */
  padding-left: 6px;
  padding-right: 6px;
  width: 28px;
  padding-bottom: 3px;
  padding-top: 0px;

  height: 28px;
  margin-left: 10px;
`;
